import React from "react";
import { Star, ShieldCheck } from "lucide-react";

function TestimonialCard({ t }) {
  return (
    <div className="w-[320px] sm:w-[380px] shrink-0 mx-3 rounded-2xl glass p-6 border border-white/10 hover:border-amber-400/40 transition">
      <div className="flex items-center gap-3 mb-4">
        {t.avatar_url ? (
          <img
            src={t.avatar_url}
            alt={t.name}
            className="w-12 h-12 rounded-full object-cover ring-2 ring-amber-400/40"
          />
        ) : (
          <div className="w-12 h-12 rounded-full ring-2 ring-amber-400/40 bg-gradient-to-br from-[#E50914] to-[#F59E0B] flex items-center justify-center font-display font-bold text-white">
            {t.name?.charAt(0) || "?"}
          </div>
        )}
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-white truncate">{t.name}</div>
          <div className="text-xs text-slate-400 truncate">{t.location}</div>
        </div>
        <div className="text-amber-400 flex items-center gap-0.5">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} size={12} fill="currentColor" strokeWidth={0} />
          ))}
        </div>
      </div>
      <p className="text-sm text-slate-300 leading-relaxed line-clamp-4">"{t.comment}"</p>
      <div className="mt-4 inline-flex items-center gap-1.5 gold-pill text-[11px] font-semibold px-3 py-1 rounded-full">
        <ShieldCheck size={12} /> {t.role}
      </div>
    </div>
  );
}

export default function TestimonialsMarquee({ testimonials }) {
  const ltr = testimonials.filter((t) => t.direction === "ltr");
  const rtl = testimonials.filter((t) => t.direction === "rtl");
  const rows = [
    { items: ltr.length ? ltr : testimonials.slice(0, Math.ceil(testimonials.length / 2)), cls: "marquee-track-ltr" },
    { items: rtl.length ? rtl : testimonials.slice(Math.ceil(testimonials.length / 2)), cls: "marquee-track-rtl" },
  ];

  return (
    <div className="marquee-container space-y-6" data-testid="testimonials-marquee">
      {rows.map((row, i) => (
        <div key={i} className="overflow-hidden relative">
          <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-r from-[#0D0F12] to-transparent" />
          <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-l from-[#0D0F12] to-transparent" />
          <div className={`flex ${row.cls}`}>
            {[...row.items, ...row.items].map((t, idx) => (
              <TestimonialCard key={`${i}-${idx}`} t={t} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
